import BaseModal from "../BaseModal";
import {Modal} from "react-bootstrap";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {actionChangeStatusShowModalMyDiscounts} from "../../../../../redux/actions/modals/modalMyDiscounts.actions";
import {FaInfoCircle, FaTimesCircle} from "react-icons/all";
import swal from "sweetalert";
import _ from "lodash";
import LoaderModals from "../../loaders/LoaderModals";

const ModalMyDiscounts = () => {

    const dispatch = useDispatch();
    const {status_show_modal, codes, loader_modal} = useSelector(state => state.modalMyDiscounts);
    const {token} = useSelector(state => state.user);

    const handleClose = () => {
        dispatch(actionChangeStatusShowModalMyDiscounts(false));
    }

    useEffect(() => {
        if (status_show_modal) {
            dispatch({type: 'FETCH_MY_DISCOUNTS', payload: {token}});
        }
        // eslint-disable-next-line
    }, [status_show_modal]);

    const clickInfoDiscount = () => {
        swal({
            text: "در صورت حساب نهایی سفارش از قسمت ورود کد تخفیف می توانید کدهای فعال خود را مشاهده و انتخاب کنید.",
            button: "تایید",
            icon: "info",
        });
    }

    return (
        <React.Fragment>
            <BaseModal title='تخفیف های من'
                       show={status_show_modal}
                       dialogClassName=''
                       handleClose={handleClose}>
                <Modal.Body>
                    {!loader_modal ?
                        <div className='box-modal-my-discounts'>
                            {codes.length > 0 ?
                                <div className='list-modal-my-discounts'>
                                    {_.map(codes, (code, index) =>
                                        <div className='item-modal-my-discounts' key={index}>
                                            <div className='part-right-item-modal-my-discounts'>
                                                <div className='box-code-discount-my-modal'>
                                                    <div>
                                                        <span>کدتخفیف: </span>
                                                        <span>{code.code}</span>
                                                    </div>
                                                    <div>
                                                        <FaInfoCircle className='icon-info-my-discount'
                                                                      onClick={clickInfoDiscount}/>
                                                    </div>
                                                </div>
                                                <div>
                                                    <p>
                                                        <span>تاریخ انقضا: </span>
                                                        <span>{code.expire_date ? code.expire_date : 'ندارد'}</span>
                                                    </p>
                                                    <p>
                                                        <span>حداقل خرید: </span>
                                                        <span>
                                                            {
                                                                code.min_purchase_amount && parseInt(code.min_purchase_amount) !== 0
                                                                    ? parseInt(code.min_purchase_amount).toLocaleString() + ' تومان'
                                                                    : 'ندارد'
                                                            }
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span>سقف تخفیف: </span>
                                                        <span>
                                                            {
                                                                code.max_discount_price && parseInt(code.max_discount_price) !== 0 ?
                                                                    parseInt(code.max_discount_price).toLocaleString() + ' تومان'
                                                                    : 'ندارد'
                                                            }
                                                        </span>
                                                    </p>
                                                    <p>
                                                        <span>توضیح: </span>
                                                        <span>{code.desc ? code.desc : 'ندارد'}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='part-left-item-modal-my-discounts'>
                                                <div>{code.amount}</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                :
                                <div className={'box-not-find-transaction-modal-wallet'}>
                                    <div className={'not-find-transaction-modal-wallet'}>
                                        <FaTimesCircle className={'icon-not-find-transaction-modal-wallet'}/>
                                        <p>کد تخفیفی برای شما وجود ندارد.</p>
                                    </div>
                                </div>
                            }
                        </div>
                        : <LoaderModals/>}
                </Modal.Body>
            </BaseModal>
        </React.Fragment>
    )
}

export default ModalMyDiscounts;